
import React, { ReactNode } from "react";

interface AdminContainerProps {
  children: ReactNode;
}

const AdminContainer: React.FC<AdminContainerProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="flex-1 p-4 sm:p-6 lg:p-8">
        <div className="container mx-auto max-w-6xl">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminContainer;
